import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import ECFForwarding from './ECFForwarding';

storiesOf('CaseFolder/Settings/ECF Forwarding', module)
  .add('Loading', () => (
    <div>
      <h3>Component can be in a loading state while we fetch data</h3>
      <hr/>
      <ECFForwarding loading={ true } />
    </div>
  ))

  .add('Account Default', () => (
    <div>
      <h3>When no overrides are specified for this CaseFolder, we show a faded edit form.</h3>
      <h4>Toggling the Override checkbox makes the form come alive</h4>
      <h4>In this example, user doesn't have permission to attach PDFs</h4>
      <hr/>

      <ECFForwarding
        onSaveSettings={ action('onSaveSettings') }
        settings={sampleGlobalSettings}
        permissions={{}}
      />
    </div>
  ))

  .add('Overriden', () => (
    <div>
      <h3>When settings are overriden, form is displayed non-faded by default</h3>
      <hr/>

      <ECFForwarding
        onSaveSettings={ action('onSaveSettings') }
        settings={sampleOverrideSettings}
        permissions={{ can_attach_pdf: true }}
      />
    </div>
  ))



const sampleGlobalSettings = {
  is_global: true,
  destinations: [
    'lawyer@firm.com',
    'paralegal@firm.com',
  ],
  all_case_emails: false,
  attach_pdf: false,
  link_to_combined_pdf: true,
}

const sampleOverrideSettings = {
  is_global: false,
  destinations: [
    'onlyparalegal@firm.com',
  ],
  all_case_emails: true,
  attach_pdf: true,
  link_to_combined_pdf: false,
}




/** WEBPACK FOOTER **
 ** ./src/CaseFolder/Settings/ECFForwarding.stories.jsx
 **/